import { render } from "./LegoOrderMain.vue?vue&type=template&id=55ab9fbe"
import script from "./LegoOrderMain.vue?vue&type=script&lang=js"
export * from "./LegoOrderMain.vue?vue&type=script&lang=js"
script.render = render

export default script